export const onPath = path => {
  const isInclude = window.location.pathname.includes(path)

  return isInclude
}
